import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import RowAndColumnSpacing from './row';
import RecipeReviewCard from './Card';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Kurzy" {...a11yProps(0)} />
          <Tab label="Softvérové služby" {...a11yProps(1)} />
          <Tab label="Kontakt" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <h1>Kurzy</h1>
        <RowAndColumnSpacing></RowAndColumnSpacing>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <h1>Softvérové služby</h1>
      <div class="project_box">
        <h2>Projekty</h2>
        <h4>Na ktorých sme spolupracovali</h4>
        <p>Autoapp</p>
        <p>Svoradov</p>
        <p>PS Diagram</p>
        <p>TradeBot</p>
        <p>Outsourcing</p>
      </div>
      <div class="technology_box">
        <h2>Technológie</h2>
        <h4>Ktoré máme radi</h4>
        <p>Java/Kotlin</p>
        <p>Python</p>
        <p>React/Angular</p>
        <p>Github/Gitlab</p>
        <p>AWS/Azure/Firebase</p>
        <p>Figma</p>
      </div>
      <div class="team_box">
        <h2>Experti</h2>
        <h4>Ktorí tvoria náš team</h4>
        <p>Scrum Masteri/Projektoví Manažéri</p>
        <p>Developeri</p>
        <p>QA/DevOps/Testeri</p>
        <p>Web Dizajnéri</p>
        <p>Dátoví analytici</p>
        <p>Softvéroví architekti</p>
      </div>
      
      </TabPanel>
      <TabPanel value={value} index={2}>
      email: 
      jozefsulek63@gmail.com
      </TabPanel>
    </Box>
  );
}